export const TIPOS_MOVIMIENTO = {
  RECARGA: 1,
  DESCUENTO: 2,
}

export const TIPO_DOCUMENTO = {
  NOTA_CREDITO: 2,
}
